<script>
export default {
    data: () => ({
        billingCodeRules: [
            v => !!v || 'Billing Code is required',           
        ],
        descriptionRules: [
            v => !!v || 'Description is required',            
        ],
        amountRules: [
            v => !!v || 'Amount is required',
            v => /^\d+(\.\d{1,2})?$/.test(v) || 'Amount must be a valid currency format',
        ],
        minutesRules: [
            v => !!v || 'Time Worked is required',
        ],
        quantityRules: [
            v => !!v || 'Quantity is required',
            v => /^\d+$/.test(v) || 'Quantity must be a positive number',
        ],
        
    }), 
    computed: {
        companyBillingCodes() {
            let companyBillingCodes = this.$store.getters.companyBilling.codes;
            let billingCodes = Array.isArray(companyBillingCodes) ? companyBillingCodes.filter(item => item.enabled === true) : [];
            return billingCodes;
        },
        billingCodeTimeWorked() {
            let companyOptions = this.$store.getters.companyOptions;
            let option = companyOptions.filter(item => item.option.startsWith('BILLING_MODULE_TIME_'));  
            let billingCodeTimeWorked = JSON.parse(option[0].value);
            return  billingCodeTimeWorked;
        },
        showBillingAmount() {            
            let userGroup = this.$store.getters.user.ingroup;
            // is userGroup admin or sysop
            if (userGroup === 'Director' || userGroup === 'Administrator' || userGroup === 'SYSOP') {
                return true;
            }          
            return false;
        },
        responses_billing () {
            let responses_billing = this.$store.getters.ticketDetails?.Ticket_ResponsesBilling ? this.$store.getters.ticketDetails.Ticket_ResponsesBilling : [];
            return responses_billing;          
        },
    },
    methods: {
        // formatCurrency(event) {
        //     let value = event.target.value;
        //     value = value.replace(/[^0-9.]/g, '');
        //     value = value.replace(/(\..*)\./g, '$1');
        //     event.target.value = value;
        // },
        getBillingMinutesLabel(value) {
            let companyOptions = this.$store.getters.companyOptions;
            let option = companyOptions.find(item => item.option.startsWith('BILLING_MODULE_TIME_'));
            let options = option ? JSON.parse(option.value) : [];
            let billingMinutesLabel = options.find(item => item.value === value);
            return billingMinutesLabel?.label || '';
        },
        // formatCurrency(amt) {
        //     if (isNaN(amt)) {
        //         return '';
        //     } else {
        //         return parseFloat(amt).toFixed(2);
        //     }                
        // },
    },
};
</script>
